import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import beaconsReducer from './slices/beaconsSlice';
import peopleReducer from './slices/peopleSlice';
import meetingsReducer from './slices/meetingsSlice';
import chatReducer from './slices/chatSlice';
export const store = configureStore({
    reducer: {
        auth: authReducer,
        ui: uiReducer,
        beacons: beaconsReducer,
        people: peopleReducer,
        meetings: meetingsReducer,
        chat: chatReducer,
    },
});
